<ng-container>
  <gbc-breadcrumb [pageInfo]="pageInfo"></gbc-breadcrumb>
  <gbc-stepper
    #stepper
    linear
    (selectionChange)="stepperChange($event)"
    (done)="done()"
    [nextDisabled]="(canContinue$ | async) === false"
    [doneDisabled]="(canContinue$ | async) === false"
    [backLabel]="'app-back' | translate"
    [nextLabel]="'app-next' | translate"
    [doneLabel]="'app-done' | translate"
    >
    <cdk-step [label]="'upgrade-flow.subscription-type' | translate">

      <!-- TODO: Temporarily show warning until upgrade works properly in GBC -->
      <gbc-banner type="warning" class="mt-2">
        <p style="font-weight: bold;">Please note that upgrading via the BuildingConnect site is currently not possible.</p>
      </gbc-banner>
      <gbc-banner type="info" class="mt-2">
        <p>If possible, we recommend upgrading via the GO Remote app instead. We apologize for the inconvenience.</p>
      </gbc-banner>
      <!-- TODO END -->

      <gbc-tile [title]="'upgrade-flow.select-license-tile-title' | translate">
        <div class="license-grid">
          @if (oneTimeFeeLicenseCategory$ | async; as otfCategory) {
            @for (license of otfCategory.licenses; track license) {
              <app-content-tile [title]="'upgrade-flow.' + license.translationKey + '-title' | translate" class="license">
                <figure>
                  @if (license.translationKey === 'building-connect') {
                    <img src="./assets/svgs/bc-professional.svg" />
                  }
                  @if (license.translationKey === 'mixit-dynamic') {
                    <img src="./assets/svgs/mixit.svg" />
                  }
                </figure>
                <p>{{ 'upgrade-flow.' + license.translationKey + '-one-time-fee-paragraph' | translate }}</p>
                <ul class="benefits">
                  <li>
                    <img src="./assets/svgs/check-mark-outline.svg" /><span>{{ license.translationKey + '.benefit-1' | translate }}</span>
                  </li>
                  <li>
                    <img src="./assets/svgs/check-mark-outline.svg" /><span>{{ license.translationKey + '.benefit-2' | translate }}</span>
                  </li>
                  <li>
                    <img src="./assets/svgs/check-mark-outline.svg" /><span>{{ license.translationKey + '.benefit-3' | translate }}</span>
                  </li>
                </ul>
                <footer class="footer">
                  <div class="price">
                    <span>€{{ license.priceEuro }}</span>
                  </div>
                  <!-- TODO: Temporarily disable the button until upgrade works properly in GBC -->
                  <button gbc-button (click)="onSelectLicense(license)" class="button" disabled="">
                    @if ((selectedLicenseType$ | async) !== license.licenseType) {
                      <span>{{ 'license-selector.choose' | translate }}</span>
                    }
                    @if ((selectedLicenseType$ | async) === license.licenseType) {
                      <img src="./assets/svgs/check-mark.svg" /> <span>{{ 'license-selector.selected' | translate }}</span>
                    }
                  </button>
                </footer>
              </app-content-tile>
            }
          }
        </div>
      </gbc-tile>
    </cdk-step>
    <cdk-step [label]="'upgrade-flow.unit-selection' | translate">
      <gbc-tile>
        <app-content-tile [title]="'upgrade-flow.' + (selectedLicense$ | async)?.translationKey + '-title' | translate">
          <figure>
            @if ((selectedLicense$ | async)?.translationKey === 'building-connect') {
              <img src="./assets/svgs/bc-professional.svg" />
            }
            @if ((selectedLicense$ | async)?.translationKey === 'mixit-dynamic') {
              <img src="./assets/svgs/mixit.svg" />
            }
          </figure>
          <div>
            <p>{{ 'upgrade-flow.' + (selectedLicense$ | async)?.translationKey + '-installation-selection-paragraph' | translate }}</p>
          </div>
          <gbc-accordion [toggleTitle]="'license-upgrade.see-benefits' | translate" class="mt-4">
            <ul>
              <li>{{ (selectedLicense$ | async)?.translationKey + '.benefit-1' | translate }}</li>
              <li>{{ (selectedLicense$ | async)?.translationKey + '.benefit-2' | translate }}</li>
              <li>{{ (selectedLicense$ | async)?.translationKey + '.benefit-3' | translate }}</li>
            </ul>
          </gbc-accordion>
        </app-content-tile>
      </gbc-tile>
      <gbc-tile [title]="'trial-flow-page.units-upgrade-tile-title' | translate">
        <app-mixit-installation-selector
          [preSelectedInstallation]="preSelectedInstallation"
          [facilities$]="facilities$"
          (installationsSelect)="onSelectInstallations($event)"
        ></app-mixit-installation-selector>
      </gbc-tile>
    </cdk-step>
    <cdk-step [label]="'upgrade-flow.customer-information' | translate">
      <app-mixit-premium-billing-details
        [title]="'upgrade-flow.billing-details' | translate"
        [extendedInfo]="true"
        (licenseDataUpdate)="setLicenseInfo($event)"
        (formValidityUpdate)="setFormValidity($event)"
        >
      </app-mixit-premium-billing-details>
    </cdk-step>
    <cdk-step [label]="'upgrade-flow.summary' | translate">
      <gbc-tile [title]="'upgrade-flow.summary-selected-installations' | translate">
        <gbc-table>
          <th gbc-table-header>{{ 'trial-flow-page.location' | translate }}</th>
          <th gbc-table-header>{{ 'trial-flow-page.mixit-unit' | translate }}</th>
          <th gbc-table-header>{{ 'trial-flow-page.serial-number' | translate }}</th>
          <th gbc-table-header>{{ 'trial-flow-page.installation-date' | translate }}</th>
          @for (installation of selectedInstallationsByFacility$ | async; track installation) {
            <tr gbc-table-row>
              <td gbc-table-cell>{{ installation.location }}</td>
              <td gbc-table-cell>
                <span class="unit">
                  @if (installation.state !== null) {
                    <app-mixit-connection-status [installation]="installation"></app-mixit-connection-status>
                    }{{ installation.name }}
                  </span>
                </td>
                <td gbc-table-cell>{{ installation.serialNumber }}</td>
                <td gbc-table-cell>{{ installation.createdTimestampEpoch | date : 'dd/MM/yyyy' }}</td>
              </tr>
            }
          </gbc-table>
        </gbc-tile>
        <gbc-tile>
          @if (summary$ | async; as summary) {
            <div class="summary">
              <gbc-table>
                <tr class="header">
                  <td>Selected units</td>
                  <td colspan="2">Renewal</td>
                  <td>Total amount</td>
                </tr>
                <tr>
                  <td gbc-table-cell [ngPlural]="summary.qty">
                    <ng-template ngPluralCase="=0">
                      <h2>{{ 'upgrade-flow.units-in-total' | translate : { count: summary.qty } }}</h2>
                    </ng-template>
                    <ng-template ngPluralCase="=1">
                      <h2>{{ 'upgrade-flow.units-in-total-singular' | translate : { count: summary.qty } }}</h2>
                    </ng-template>
                    <ng-template ngPluralCase="other">
                      <h2>{{ 'upgrade-flow.units-in-total' | translate : { count: summary.qty } }}</h2>
                    </ng-template>
                  </td>
                  <td gbc-table-cell colspan="2">
                    <h2>{{ 'license.' + summary.selectedLicense.licenseType | translate }}</h2>
                  </td>
                  <td gbc-table-cell>
                    <h2>€{{ summary.price }}</h2>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <p>{{ 'upgrade-flow.terms-and-conditions' | translate }}</p>
                  </td>
                </tr>
              </gbc-table>
            </div>
          }
        </gbc-tile>
        @if ((currentStep$ | async) === 3) {
          <app-mixit-premium-billing-details
            [title]="'upgrade-flow.billing-details' | translate"
            [extendedInfo]="true"
            [licenseData]="licenseInfo$ | async"
            [readOnly]="true"
            >
          </app-mixit-premium-billing-details>
        }
      </cdk-step>
    </gbc-stepper>
  </ng-container>
